module.exports = __webpack_public_path__ + "static/media/main-video.86f2b8c5.mp4";